import React from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../common/types';
import { stateMessages } from '../messages/stateMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the editor; each part uses its own slice of it */
import styles from '../MusicVideoEditor.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface EditorNoticesProps {
  /** The director failed on the first cut: the user got the plain cut (design e1 note). */
  isDirectorFailed: boolean;
  onDismissFailed: () => void;
  /** A recut runs: the editor waits for the director and saves nothing. */
  isRecutWorking: boolean;
  /** The making line of "Make the video" (e3), or nothing. */
  making: React.ReactNode;
}

/** The notes over the preview (design e1, e3, c6). */
const EditorNoticesComponent: React.FC<EditorNoticesProps> = ({
  isDirectorFailed,
  onDismissFailed,
  isRecutWorking,
  making,
}) => {
  const intl = useIntl();
  if (!isDirectorFailed && !isRecutWorking && making === null) {
    return null;
  }
  return (
    <div className={styles.notices}>
      {making}
      {isRecutWorking && (
        <p className={styles.notice} role="status">
          <span className={styles.noticeDot} />
          {intl.formatMessage(stateMessages.recutWorking)}
        </p>
      )}
      {isDirectorFailed && (
        <p className={clsx(styles.notice, styles.noticeWarn)} role="status">
          {intl.formatMessage(stateMessages.directorFailed)}
          <button type="button" className={styles.linkButton} onClick={onDismissFailed}>
            {intl.formatMessage(stateMessages.dismiss)}
          </button>
        </p>
      )}
    </div>
  );
};

export const EditorNotices = TypedMemo(EditorNoticesComponent);
